import { writeBatch } from "firebase/firestore";
import { logBatch } from "global/cnr/reducers/reducerHelpers/logging";
import { dataFix } from "global/common/dataFix";
import { createRefPath_client } from "global/firestoreData/appData/appRefPaths";
import _ from 'lodash';
import { useCallback, useContext, useState } from "react";
import { ParentContext } from "../ParentContext";

const _allowProfileUpdates = true

export const useProfiles = () => {

  const parentContext = useContext(ParentContext);
  const { states, fns } = parentContext ?? {}
  const { app_state, paps_state } = states ?? {}
  const { mainDb } = app_state ?? {}
  const { pathViews } = paps_state ?? {}
  const { database_fns } = fns

  const [updatingProfiles, setUpdatingProfiles] = useState()

  const createProfiles = useCallback(async (profiles) => {
    setUpdatingProfiles(true)
    await create_profiles(mainDb, database_fns, pathViews, profiles)
    setUpdatingProfiles(false)
  }, []);

  return { createProfiles, updatingProfiles };
};

const create_profiles = async (mainDb, database_fns, pathViews, profiles) => {
  const batch = writeBatch(mainDb);
  // const promises = []
  _.forEach(profiles, (profile, key) => {
    const _profile = dataFix.removeAllEmpties(profile)
    const refPath = createRefPath_client(pathViews, ['profiles', key])
    database_fns.set_doc(refPath, _profile, false, false, batch);
  })

  if (_allowProfileUpdates) {
    return await batch.commit()
  }
  logBatch(batch)
  // return Promise.all(promises)
}